<template>
  <div class="SlideShowBox">
    <div @click="prev" class="change-slick-btn prev-btn" :style="{ 'top': arrowPos + 'px' }" >
      <svg xmlns="http://www.w3.org/2000/svg" width="35" height="35" viewBox="0 0 35 35">
        <g id="Group_1153" data-name="Group 1153" transform="translate(-670 -393)">
          <path id="Path_1344" data-name="Path 1344" d="M17.039,0H17.5A17.5,17.5,0,1,1,0,17.5v-.461A17.039,17.039,0,0,1,17.039,0Z" transform="translate(670 393)" fill="#202020" opacity="0.5"/>
          <path id="Path_1404" data-name="Path 1404" d="M-855,1857.5l-8,7.5,8,7.5" transform="translate(1545.5 -1454)" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
        </g>
      </svg>
    </div>
    <slick ref="slick" :options="slickOptions">
      <slot name="slick-pages" class="slick-pages"></slot>
    </slick>
    <div @click="next" class="change-slick-btn next-btn" :style="{ 'top': arrowPos + 'px' }" >
      <svg xmlns="http://www.w3.org/2000/svg" width="35" height="35" viewBox="0 0 35 35">
        <g id="Group_1154" data-name="Group 1154" transform="translate(-721 -393)">
          <path id="Path_1405" data-name="Path 1405" d="M17.961,0H17.5A17.5,17.5,0,1,0,35,17.5v-.461A17.039,17.039,0,0,0,17.961,0Z" transform="translate(721 393)" fill="#202020" opacity="0.5"/>
          <path id="Path_1406" data-name="Path 1406" d="M-863,1857.5l8,7.5-8,7.5" transform="translate(1598.5 -1454)" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
        </g>
      </svg>
    </div>
  </div>
</template>

<script>
import Slick from 'vue-slick';

export default {
  name: 'SlideShow',
  data() {
      return {
          arrowPos: 0,
          slickOptions: {
              dots: true,
              infinite: false,
              speed: 300,
              slidesToShow: 1,
              adaptiveHeight: true,
              arrows: false,
              infinite: true,
              // Any other options that can be got from plugin documentation
          },
      };
  },
  components: { Slick },
  methods: {
      next() {
          this.$refs.slick.next();
      },

      prev() {
          this.$refs.slick.prev();
      },

      reInit() {
          // Helpful if you have to deal with v-for to update dynamic lists
          this.$nextTick(() => {
              this.$refs.slick.reSlick();
          });
      },
  },
  mounted() {
    let vm = this
    let imginner = document.querySelector('.slick-page-img')
    imginner.onload = function(){
      vm.arrowPos = this.clientHeight / 2 ;
      vm.reInit()
    };
  }
}
</script>
<style lang="scss">
@import '../sass/slick.scss';

.SlideShowBox {
  width: 100%;
  position: relative;
  .slick-pages {
    width: 100%;
    .slickPage {
      a {
        text-decoration: none;
      }
      img {
        width: 100%;
      }
      .image-description {
        margin: 5.6px 0;
        color: #7b7a7a;
        text-decoration: none;
      }
    }
  }
  .change-slick-btn {
    cursor: pointer;
    width: 28px;
    height: 28px;
    @media (min-width: 768px) and (max-width: 1279.98px) {
      width: 38px;
      height: auto;
    }
    @media (min-width: 1280px) {
      width: 38px;
      height: auto;
    }
    svg {
      width: 100%;
      height: auto;
    }
    &.prev-btn {
      position: absolute;
      left: 10px;
      z-index: 1;
      top: 0;
    }
    &.next-btn {
      position: absolute;
      top: 0;
      right: 10px;
      z-index: 1;
    }
  }
}
</style>